import React, { useRef, useEffect } from 'react'
import { Item } from './styles'

type Props = {
  'data-qa'?: string
  children: string
  disabled?: boolean
  theme?: 'enabled' | 'negative' | 'active'
  onClick?: () => void
  style?: object
}

const UpperMenu: React.FC<any> = (props: Props): JSX.Element => {
  const componentRef = useRef(null)

  useEffect(() => {
    handleAddClass(componentRef)
  }, [props.onClick])

  return (
    <>
      <Item
        ref={componentRef}
        className={`upper-menu ${!props.disabled ? props.theme : ''}`}
        data-qa={props['data-qa']}
        onClick={props.onClick}
        disabled={props.disabled}
        style={props.style}
      >
        {props.children}
      </Item>
    </>
  )
}

UpperMenu.defaultProps = {
  disabled: false,
  theme: 'enabled',
}

export default UpperMenu

const handleAddClass = (ref) => {
  const CLASS_COMPONENT_NAME = 'upper-menu'
  const CLASS_COMPONET_SINGLE = 'single'
  const CLASS_COMPONENT_FIRST = 'first'
  const CLASS_COMPONENT_LAST = 'last'
  const elements =
    ref.current.parentNode.getElementsByClassName(CLASS_COMPONENT_NAME)
  const isSingleElement = elements.length === 1
  if (isSingleElement) return elements[0].classList.add(CLASS_COMPONET_SINGLE)
  const firstElement = elements[0]
  const lastElement = elements[elements.length - 1]
  firstElement.classList.add(CLASS_COMPONENT_FIRST)
  lastElement.classList.add(CLASS_COMPONENT_LAST)
}
